import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";
import { useForm, SubmitHandler } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Context } from "../..";

type FormValues = {
  password: string;
  passwordSecond: string;
};

const RestorePasswordForm: React.FC = () => {
  const { store } = useContext(Context);
  const { link } = useParams<{ link: string }>();
  const [message, setMessage] = useState<string | null>(null);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setError,
  } = useForm<FormValues>();
  const password = watch("password");
  const passwordSecond = watch("passwordSecond");

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    if (data.password !== data.passwordSecond) {
      setError("passwordSecond", {
        type: "manual",
        message: "Паролі не співпадають",
      });
      return;
    }

    if (link) {
      const response = await store.restorePassword(data.password, link);
      if (response?.status === 200) {
        setMessage('Лист для відновлення пароля було відправлено. Будь ласка, перевірте вашу пошту.');
        setTimeout(() => navigate('/'), 5000); // Через 5 секунд перенаправити на сторінку входу
      } else {
        setError('passwordSecond', { type: 'manual', message: response?.data?.message || 'Помилка при відновленні пароля' });
      }
    }
  };

  return (
    <>
      {message && <div className="message">{message}</div>}
      <form onSubmit={handleSubmit(onSubmit)} className="form__block">
        <fieldset className="form__field">
          <label htmlFor="password" className="form__label">Введіть пароль</label>
          <input
            {...register("password", {
              required: "Це поле обов'язкове",
              minLength: { value: 8, message: "Пароль має бути не менше 8 символів" },
              validate: {
                containsNumber: value => /\d/.test(value) || "Пароль повинен містити цифру",
                containsUpper: value => /[A-ZА-Я]/.test(value) || "Пароль повинен містити велику літеру",
                containsLower: value => /[a-zа-я]/.test(value) || "Пароль повинен містити маленьку літеру",
                passwordsMatch: value => value === passwordSecond || "Паролі не співпадають",
              }
            })}
            className="form__input"
            type="password"
            id="password"
          />
          {errors.password && <p className="error-message">{errors.password.message}</p>}
        </fieldset>
        <fieldset className="form__field">
          <label htmlFor="passwordSecond" className="form__label">Підтвердіть пароль</label>
          <input
            {...register("passwordSecond", {
              required: "Це поле обов'язкове",
              minLength: { value: 8, message: "Пароль має бути не менше 8 символів" },
              validate: {
                containsNumber: value => /\d/.test(value) || "Пароль повинен містити цифру",
                containsUpper: value => /[A-ZА-Я]/.test(value) || "Пароль повинен містити велику літеру",
                containsLower: value => /[a-zа-я]/.test(value) || "Пароль повинен містити маленьку літеру",
                passwordsMatch: value => value === password || "Паролі не співпадають",
              }
            })}
            className="form__input"
            type="password"
            id="passwordSecond"
          />
          {errors.passwordSecond && <p className="error-message">{errors.passwordSecond.message}</p>}
        </fieldset>
        <button className="form__submit" type="submit">Відновити пароль</button>
      </form>
    </>
  );
};

export default observer(RestorePasswordForm);
